/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React from "react";
import Label from "../../components/label";
import Anchor from "../../components/anchor";

export default function FAQsList(props) {
  let phoneTitle= props.contactDetails.phoneNumber.substring(0, 4) + ' ' + props.contactDetails.phoneNumber.substring(4, 7) + ' ' + props.contactDetails.phoneNumber.substring(7, 10);
  return (
    <div className="row contact-us">
      <div className="col-sm-6 text-center p-3">
        <div className="card">
          <div className="card-body contact-card-min-height">
            <h5 className="card-title">
              {" "}
              <i className="fas fa-phone-alt w-100 icon"></i>
            </h5>
            <Label className="gray large w-100 title" title="Call Support" />
            <Anchor
              title={phoneTitle}
              className="anchor text-decoration-none primary-color"
              // href="tel:1300003310"
              href={"tel:"+props.contactDetails.phoneNumber}
              target="_blank"
            />
          </div>
        </div>
      </div>
      <div className="col-sm-6 text-center p-3">
        <div className="card">
          <div className="card-body contact-card-min-height">
            <h5 className="card-title">
              {" "}
              <i className="fas fa-envelope w-100 icon"></i>
            </h5>
            <Label className="gray large w-100 title" title="Email Support" />
            <Anchor
              // title="support@instantconsult.com.au"
              title={props.contactDetails.email}
              className="anchor text-decoration-none primary-color"
              // href="mailto:support@instantconsult.com.au"
              href={"mailto:"+props.contactDetails.email}
              target="_blank"
            />
          </div>
        </div>
      </div>
      <div className="col-sm-6 text-center p-3">
        <div className="card">
          <div className="card-body contact-card-min-height contact-card-center-align">
            <h5 className="card-title">
              {" "}
              <i className="fas fa-book w-100 icon"></i>
            </h5>
            {/* <Label className="gray large w-100 title" title="Good Practice & Safe Prescribing Policy Book" /> */}
            <Anchor
              // title="support@instantconsult.com.au"
              title={'Good Practice &'}
              className="gray large w-100 title normal-text"
              // href="mailto:support@instantconsult.com.au"
              href={props.contactDetails.goodPracticePolicy ? props.contactDetails.goodPracticePolicy : ''}
              target="_blank"
            />
            <Anchor
              // title="support@instantconsult.com.au"
              title={'Safe Prescribing Policy Book'}
              className="gray large w-100 title normal-text"
              // href="mailto:support@instantconsult.com.au"
              href={props.contactDetails.goodPracticePolicy ? props.contactDetails.goodPracticePolicy : ''}
              target="_blank"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
